import { makeServerRequest } from './util';

const apiPrefix = "/api/v1/customers";

export const fetchCustomers = () => {

    return (dispatch) => {
        dispatch({type: "FETCH_CUSTOMERS"});

        return makeServerRequest(apiPrefix + "?size=1000").then(
            response => dispatch(fetchCustomersSuccess(response.data))
        ).catch(
            error => dispatch(fetchCustomersFailure(error))
        );
    };
};

export function fetchCustomersSuccess(customers) {
    return {
        type: "FETCH_CUSTOMERS_SUCCESS",
        payload: customers
    };
}

export function fetchCustomersFailure(error) {
    return {
        type: "FETCH_CUSTOMERS_FAILURE",
        payload: error
    };
}

export const fetchCustomer = (id) => {

    return (dispatch) => {
        dispatch({type: "FETCH_CUSTOMER"});

        return makeServerRequest(apiPrefix + "/" + id).then(
            response => dispatch(fetchCustomerSuccess(response.data))
        ).catch(
            error => dispatch(fetchCustomerFailure(error))
        );
    };
};


export function fetchCustomerSuccess(customer) {
    return {
        type: "FETCH_CUSTOMER_SUCCESS",
        payload: customer
    };
}


export function fetchCustomerFailure(error) {
    return {
        type: "FETCH_CUSTOMER_FAILURE",
        payload: error
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/customers.js